import React from "react";
import { Eye } from "lucide-react";

const windowCopy = (it) => {
  if (it._window === "window") {
    return it.timing_phrase ? `Held for ${it.timing_phrase}. No exact date needed.` : "Held as a window.";
  }
  return it._window === "weekend" ? "This is coming up this weekend." : "This is coming up this week.";
};

// Context-aware return v1: a calm pre-window prompt for held horizon items the Daily nudge
// can't catch. Returns things the user already saved — never invents urgency.
export const WorthALookCard = ({ items, onOpen, onSnooze }) => {
  if (!items || items.length === 0) return null;
  return (
    <div
      data-testid="worth-a-look-card"
      className="mb-8 rounded-2xl bg-[var(--surface)] border border-[var(--line)] p-5 md:p-6"
    >
      <div className="flex items-center gap-2 mb-1">
        <span className="text-[var(--pine)]"><Eye size={16} strokeWidth={1.9} /></span>
        <h2 className="font-heading font-medium text-[var(--ink)] text-base">Worth a look</h2>
      </div>
      <p className="text-sm text-[var(--ink3)] mb-4">No rush — here when you want it.</p>

      <div className="space-y-3">
        {items.map((it) => (
          <div
            key={it.id}
            data-testid={`worth-a-look-item-${it.id}`}
            className="flex items-start justify-between gap-3 rounded-xl bg-[var(--surface2)] border border-[var(--line)] px-3.5 py-3"
          >
            <div className="min-w-0">
              <p className="text-[var(--ink)] font-medium truncate">{it.interpreted_summary}</p>
              <p className="text-xs text-[var(--ink5)] mt-0.5">{windowCopy(it)}</p>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <button
                data-testid={`worth-a-look-open-${it.id}`}
                onClick={() => onOpen(it.id)}
                className="rounded-full bg-[var(--pine)] hover:bg-[var(--pine-dark)] text-[var(--on-pine)] text-[13px] font-medium px-3.5 py-1.5 transition-colors"
              >
                Open
              </button>
              <button
                data-testid={`worth-a-look-snooze-${it.id}`}
                onClick={() => onSnooze(it.id)}
                className="rounded-full border border-[var(--line)] hover:bg-[var(--surface)] text-[var(--ink3)] text-[13px] font-medium px-3.5 py-1.5 transition-colors"
              >
                Not now
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
